import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { ClaimsService } from "../../_services/common/claims.service";
import { Subscription } from "rxjs";
import { Userresponsedto } from "../../_models/user/userresponsedto";
import { Claims } from "../../_models/common/claims";
import { AuthenticationService } from "../../_services";
import { BaseComponent } from '../../shared/base/base-component';
import { TranslateService } from "@ngx-translate/core";
import { GridConfig } from "../../_models/common/grid/grid-config";
import { ColDef } from "ag-grid-community";
import { AppGridComponent } from "../../shared/grid/grid-component/grid.component";
import { ApiRequest, LogObjectActionTemplateEnum } from "../../_models";
import { ReqReceiptTypeDetails } from "../../_models/vat-novat-receipt/vat-novat-receipt";
import { environment } from "../../../environments/environment";
import { OrganisationSettingService } from "../../_services/organisation-setting/organisation-setting.service";
import { first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { AlertService } from 'src/app/alert-panel/alert.service';
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { LoggingPanelService } from "src/app/_services/logging-panel/logging-panel.service";
import { LoggingPanelModel } from "src/app/_models/common/LoggingPanelModel";
@Component({
  selector: "app-manage-vat-steps",
  templateUrl: "./manage-vat-steps.component.html",
  standalone: false
})

export class ManageVatStepsComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() stepNum: number;
  @Input() vatNoVatReceiptDetails: any;
  @Input() panelHeading: string;
  @Input() backBtnText: string;
  @Output() closePanelEvent = new EventEmitter<boolean>();
  currentUserSubscription: Subscription;
  currentUser: Userresponsedto;
  claims: Claims;
  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  gridConfigItems: GridConfig;
  gridColumnDefs: ColDef[];
  gridData: any = [];
  noDataAvailableMessage: string;
  hasFormChanges: boolean;
  userId: number;
  alertSubscription: Subscription;
  isValueChanged: boolean = false;
  howDoIVideoLinks = HowDoIVideoLinks;
  videoLink: string = "";
  constructor(
    private authenticationService: AuthenticationService,
    private claimsService: ClaimsService,
    private translate: TranslateService,
    private organisationSettingService: OrganisationSettingService,
    private toastr: ToastrService,
    private alertService: AlertService,
    private loggingPanelService: LoggingPanelService,
  ) {
    super();
    this.claimsService.currentClaims.subscribe(claims => this.claims = claims);
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(
      user => {
        this.currentUser = user;
      }
    );
    var currentContext = this;
    this.alertSubscription = this.alertService.getUserActionEvent().subscribe(action => {
      if (action) {
        if (currentContext.hasFormChanges) {
          this.closePanelEvent.emit(true);
        }
        else {
          if (!this.fnIsStepNum1Valid()) {
            this.closePanelEvent.emit(true);
          } else {
            currentContext.hasFormChanges = false;
            currentContext.fnBacktoWizard();
          }
        }
      }
    });
  }

  ngOnInit() {
    if (this.backBtnText) {
      this.backBtnText = this.translate.instant(this.backBtnText);
    }
    else {
      this.backBtnText = this.translate.instant('back_to_wizard');
    }
    this.stepNum = this.stepNum - 1;
    this.isValueChanged = false;
    this.hasFormChanges = false;
    this.userId = this.claims.UserId;
    this.getVideoLink();
    this.fnInitialiseGrid();
    this.fnGetReceiptTypeSettings();
  }

  getVideoLink() {
    switch (this.stepNum) {
      case 1:
        this.videoLink = this.howDoIVideoLinks.ConfigureNamesOfRecieptTypes;
        break;
      case 2:
        this.videoLink = this.howDoIVideoLinks.TurnOnReceiptTypeDisplayToClaimant;
        break;
      case 3:
        this.videoLink = this.howDoIVideoLinks.ConfigurePolicyViolationTaxNoTax;
        break;
    }
  }

  ngOnChanges(changes) {
    if (this.backBtnText) {
      this.backBtnText = this.translate.instant(this.backBtnText);
    }
    else {
      this.backBtnText = this.translate.instant('back_to_wizard');
    }
    this.gridData = this.vatNoVatReceiptDetails;
    setTimeout(() => {
      this.gridComponent.refreshData();
    }, 100);
  }

  canDeactivate(): boolean {
    return !this.hasFormChanges;
  }

  ngOnDestroy() {
    this.videoLink = "";
    this.alertSubscription.unsubscribe();
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [];
    if (this.stepNum === 1) {
      this.gridColumnDefs.push(
        {
          headerName: this.translate.instant('default_settings'),
          field: 'setupName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 600,
          maxWidth: 600,
          cellClass: 'text-left',
          headerClass: 'text-left'
        },
        {
          headerName: this.translate.instant('display_name_subtext'),
          field: 'deriveName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 250,
          // maxWidth: 600,      
          cellClass: 'text-left',
          headerClass: 'text-left',
          cellRenderer: 'gridTextBoxRenderer',
          valueSetter: params => { params.data.receiptType = params.newValue; params.data.deriveName = params.newValue; return true; },
          // onCellValueChanged: params => this.hasFormChanges = true
          cellRendererParams: {
            onInput: this.fnOnDisplayNameInput.bind(this),
          },
        });
    }
    else if (this.stepNum == 2) {
      this.gridColumnDefs.push(
        {
          headerName: this.translate.instant('default_settings'),
          field: 'setupName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 400,
          maxWidth: 400,
          cellClass: 'text-left',
          headerClass: 'text-left'
        },
        {
          headerName: this.translate.instant('display_name_subtext'),
          field: 'deriveName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 400,
          maxWidth: 400,
          cellClass: 'text-left',
          headerClass: 'text-left'
        },
        {
          headerName: this.translate.instant('display_do_not_display'),
          field: 'isSwitchedOn',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 400,
          maxWidth: 400,
          cellRenderer: 'toggleRenderer'
        });
    }
    else if (this.stepNum == 3) {
      this.gridColumnDefs.push(
        {
          headerName: this.translate.instant('default_settings'),
          field: 'setupName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 300,
          maxWidth: 300,
          cellClass: 'text-left',
          headerClass: 'text-left'
        },
        {
          headerName: this.translate.instant('display_name_subtext'),
          field: 'deriveName',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 300,
          maxWidth: 300,
          cellClass: 'text-left',
          headerClass: 'text-left'
        },
        {
          headerName: this.translate.instant('display_do_not_display'),
          field: 'isSwitchedOn',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 200,
          maxWidth: 200,
          cellRenderer: 'toggleRenderer'
        },
        {
          headerName: this.translate.instant('policy_violation_apply_do_not_apply'),
          field: 'isSwitchedOn2',
          resizable: true,
          sortable: true,
          suppressHeaderMenuButton: true,
          minWidth: 300,
          maxWidth: 300,
          cellRenderer: 'toggleRendererSecond'
        });
    }

  }

  fnGetGridConfigItems() {
    let countByStatusArray = [];
    this.gridConfigItems = new GridConfig(
      true,
      true,
      "sequenceNumber",
      "sequenceNumber",
      0,
      false,
      countByStatusArray,
      true,
      true,
      true,
      null,
      'asc',
      40,
      'no_data_availabe',
      null,
      null,
      false,
      false,
      '',
      '',
      false
    );
  }

  fnInitialiseGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.initializeGrid(false);
    }, 100);
  }

  fnOnGridCellClick(params) {
    let item = params.data;
    if (this.gridData.filter(it => it.vatNoVatReceiptTypeId == item.vatNoVatReceiptTypeId).length > 0) {
      for (var i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].vatNoVatReceiptTypeId == item.vatNoVatReceiptTypeId) {
          // if(this.gridData[i].receiptType != item.deriveName)
          // { 
          //   this.gridData[i].receiptType = item.deriveName;
          //   this.hasFormChanges = true;            
          // }

          if (this.gridData[i].isDisplayOn != item.isSwitchedOn || this.gridData[i].isPolicyViolationOn != item.isSwitchedOn2) {
            this.hasFormChanges = true;
            this.gridData[i].isDisplayOn = item.isSwitchedOn2 && !item.isSwitchedOn && !this.gridData[i].isDisplayOn ? true : item.isSwitchedOn;
            this.gridData[i].isSwitchedOn = this.gridData[i].isDisplayOn;
            this.gridData[i].isPolicyViolationOn = item.isSwitchedOn ? item.isSwitchedOn2 : false;
            this.gridData[i].isSwitchedOn2 = this.gridData[i].isPolicyViolationOn;
            this.gridComponent.redrawGridRows();
          }
        }
      }
    }
  }

  fnUpdateReceiptTypeSettings() {
    let invalidValidation = false;
    this.isValueChanged = this.hasFormChanges;
    if (this.stepNum == 1) {
      this.gridData.forEach(element => {
        if (element.deriveName.trim() == "") {
          invalidValidation = true;
        }
      });
    }
    if (!invalidValidation) {
      let reqReceiptTypeDetails = new ApiRequest<ReqReceiptTypeDetails>("UpdateReceiptTypeSettings", environment.applicationVersion, environment.requestId);
      let reqReceiptTypeDetailsInfo = new ReqReceiptTypeDetails();
      reqReceiptTypeDetailsInfo.lstReceiptTypeDetails = this.gridData;
      reqReceiptTypeDetailsInfo.userId = this.userId;
      reqReceiptTypeDetailsInfo.isNameChanged = this.stepNum == 1 && !this.hasFormChanges ? true : false;
      reqReceiptTypeDetailsInfo.isDisplayChanged = this.stepNum == 2 && !this.hasFormChanges ? true : false;
      reqReceiptTypeDetailsInfo.isPolicyChanged = this.stepNum == 3 && !this.hasFormChanges ? true : false;
      reqReceiptTypeDetails.requestInfo = reqReceiptTypeDetailsInfo;

      this.organisationSettingService
        .updateVatNoVatReceiptType(reqReceiptTypeDetails)
        .pipe(first())
        .subscribe(
          (data) => {
            if (data.responseInfo) {
              if (this.isValueChanged) {
                this.toastr.success(this.translate.instant("success"));
                this.fnGetReceiptTypeSettings();
              }
              else {
                this.closePanelEvent.emit(true);
              }
              this.hasFormChanges = false;
            }
          },
          (error) => {
            this.toastr.error(error);
          }
        );
    }
  }

  fnGetReceiptTypeSettings() {
    this.organisationSettingService
      .getVatNoVatReceiptType()
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.responseInfo != null) {
            this.gridData = data.responseInfo.receiptTypes.map(e => this.mapReceiptType(e));
            setTimeout(() => {
              this.gridComponent.refreshData();
            }, 100);
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      );
  }

  mapReceiptType(e): any {
    let receiptTypeDetail: any = e;
    receiptTypeDetail.deriveName = e.receiptType;
    receiptTypeDetail.isSwitchedOn = e.isDisplayOn;
    receiptTypeDetail.isSwitchedOn2 = e.isPolicyViolationOn;
    receiptTypeDetail.informationId = e.vatNoVatReceiptTypeId;
    receiptTypeDetail.isHidden = e.sequenceNumber == 1 ? true : false;
    receiptTypeDetail.showText = true;
    receiptTypeDetail.showSwitchText = this.translate.instant('displayed');
    receiptTypeDetail.showSwitchText2 = this.translate.instant('applied');
    return receiptTypeDetail;
  }

  fnBacktoWizard() {
    if (this.canDeactivate()) {
      if (!this.fnIsStepNum1Valid()) {
        this.alertService.onFormClosed();
        return;
      }
      if (this.stepNum < 4 && !this.isValueChanged) {
        this.fnUpdateReceiptTypeSettings();
      }
      else {
        this.closePanelEvent.emit(true);
      }
    }
    else {
      this.alertService.onFormClosed();
    }
  }

  //4 different variables for each row in grid
  isReceiptType1TextBoxEmpty: boolean = false;
  isReceiptType2TextBoxEmpty: boolean = false;
  isReceiptType3TextBoxEmpty: boolean = false;
  isReceiptType4TextBoxEmpty: boolean = false;
  fnOnDisplayNameInput(data) {
    if (data) {
      let sequenceNumber = data.rowData.sequenceNumber;
      let text = data.rowData.deriveName.trim();
      switch (sequenceNumber) {
        case 1: text === "" ? this.isReceiptType1TextBoxEmpty = true : this.isReceiptType1TextBoxEmpty = false;
          break;
        case 2: text === "" ? this.isReceiptType2TextBoxEmpty = true : this.isReceiptType2TextBoxEmpty = false;
          break;
        case 3: text === "" ? this.isReceiptType3TextBoxEmpty = true : this.isReceiptType3TextBoxEmpty = false;
          break;
        case 4: text === "" ? this.isReceiptType4TextBoxEmpty = true : this.isReceiptType4TextBoxEmpty = false;
          break;
      }
      this.hasFormChanges = this.fnIsStepNum1Valid();
    }
  }

  fnIsStepNum1Valid(): boolean {
    return !(this.isReceiptType1TextBoxEmpty || this.isReceiptType2TextBoxEmpty || this.isReceiptType3TextBoxEmpty || this.isReceiptType4TextBoxEmpty);
  }

  fnShowConfigureshowLoggingAlertPanel() {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.VatNoVatReceiptType.toString(),
      "0"
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

}